import { inject } from '@angular/core';
import { RedirectCommand, Router, type CanActivateFn } from '@angular/router';

import { AuthService } from './auth.service';

export const autoRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return new RedirectCommand(router.parseUrl('/dashboard'));
  }

  return true;
};
